import { InternalAndGuestUserRoles, InternalUserRoles } from "../../constants/roles";
import Sandbox from "../../pages/Sandbox";
import Notifications from "../../pages/Notifications";
import UPrefs from "../../pages/UserPreferences";
import GlobalSearch from "../../pages/GlobalSearch";
import Logout from "../../pages/External";
import Tutorials from "../../pages/Tutorials";
import Help from "../../pages/Help";
import { RouteConfig } from "../types";

export const userServicesRoutes: { [key: string]: RouteConfig } = {
  profile: {
    path: "/profile",
    component: UPrefs,
    allowedRoles: InternalAndGuestUserRoles,
  },
  notifications: {
    path: "/notifications",
    component: Notifications,
    allowedRoles: InternalAndGuestUserRoles,
  },
  help: {
    path: "/help",
    component: Help,
    allowedRoles: [],
  },
  search: {
    path: "/search",
    component: GlobalSearch,
    allowedRoles: InternalUserRoles,
  },
  logout: {
    path: "/logout",
    component: Logout,
    allowedRoles: [],
  },
  tutorials: {
    path: "/tutorials",
    component: Tutorials,
    allowedRoles: InternalUserRoles,
  },
  sandbox: {
    path: "/sandbox",
    component: Sandbox,
    allowedRoles: InternalUserRoles,
  },
};
